// @flow
import type { NewsletterSubscriptionType, RawNewsletterSubscriptionType } from 'types/NewsletterSubscription';
import { mergeIntoDefault } from 'utils/objectUtils';
import { nullNewsletterSubscription } from 'types/NewsletterSubscription';

export function convertOptionsFromApi(
  rawNewsletterSubscription: RawNewsletterSubscriptionType[]
): NewsletterSubscriptionType {
  if (!rawNewsletterSubscription) {
    return nullNewsletterSubscription;
  }

  const jeSuis = rawNewsletterSubscription.filter((field) => field.FieldName === 'Je suis');

  if (jeSuis.length === 0) {
    return nullNewsletterSubscription;
  }

  const { FieldName, Key, FieldOptions } = jeSuis[0];

  return mergeIntoDefault(nullNewsletterSubscription, {
    field: FieldName,
    key: Key,
    options: FieldOptions
  });
}
